// Alias overrides for common variations
const aliasOverrides = {
  BANKOFAMERICA: "BANK_OF_AMERICA",
  JPMORGANCHASE: "JPMORGANBANK",
  JPMORGAN: "JPMORGANBANK",
  WELLSFARGOBANK: "WELLSFARGO",
  WELLSFARGO: "WELLSFARGO",
  PNCBANK: "PNC",
  PNC: "PNC",
  CENTRALNATIONALBANKTRUST: "CENTRAL_NATIONAL_BANK",
  CENTRALNATIONALBANK: "CENTRAL_NATIONAL_BANK",
  CITIBANK: "CITI",
  SUNTRUSTBKCENTRALFL: "SUNTRUST",
  ROGUEFEDERALCREDITUNION: "ROGUEFEDERALCREDITUNION",
  ROGUE_FEDERAL_CREDIT_UNION: "ROGUEFEDERALCREDITUNION",
  TD_BANK: "TDBANK",
  USAA: "USAAFEDERALBANK",
  USAAFEDERALBANK: "USAAFEDERALBANK",
  USAA_FEDERAL_BANK: "USAAFEDERALBANK",
  CHARLESSCHWAB: "SCHWAB",
  DELTACOMMUNITY: "DELTA",
  ALLIANT: "ALLIANTCREDITUNION",
  PATELCO: "PATELCOCREDITUNION",
  PATELCO_CREDIT_UNION: "PATELCOCREDITUNION",
  MIDDLESEX: "MIDDLESEXFEDFA",
  DISCOVER: "DISCOVERBANK",
  DISCOVER_BANK: "DISCOVERBANK",
  KEYBANKNATIONAL: "KEYBANKNATIONAL",
  KEY_BANK_NATIONAL: "KEYBANKNATIONAL",
  FIFTH_THIRD_BANK: "FIFTHTHIRDBANK",
  REGIONS_BANK: "REGIONSBANK",
  SCHOOLSFIRST: "SCHOOLSFIRSTFEDERALCREDITUNION",
  SCHOOLSFIRSTFEDERALCREDITUNION: "SCHOOLSFIRSTFEDERALCREDITUNION",
  SCHOOLSFIRST_FEDERAL_CREDIT_UNION: "SCHOOLSFIRSTFEDERALCREDITUNION",
  SOVEREIGN: "SOVEREIGNBANK",
  SOVEREIGN_BANK: "SOVEREIGNBANK",
  SANDTBANK: "STBANK",
  S_T_BANK: "STBANK",
  S_TBANK: "STBANK",
  ST_BANK: "STBANK",
  SUNCOASTSCHOOLS: "SUNCOAST",
  BAXTER: "BCU",
  LIBERTY_BANK: "LIBERTYBANK",
  TXDOWEMPLYCREDIT: "TXDOW",
  TINKER_FEDERAL_CREDITUNION: "TINKERFEDERALCREDITUNION ",
  TRUWEST: "TRUWESTCREDITUNION ",
  TRUWEST_CREDIT_UNION: "TRUWESTCREDITUNION ",
  HUDSONVALLEY: "HUDSON_VALLEY_FCU",
  WESTERN: "WESTERN_FCU",
  M_T_BANK: "MTBANK",
  MT_BANK: "MTBANK",
  M_TBANK: "MTBANK",
  LAKE_MICHIGAN_CREDIT_UNION: "LAKEMICHIGANCREDITUNION",
  HUDSON_VALLEY: "HUDSON_VALLEY",
  FIRST_HAWAIIAN_BANK: "FIRSTHAWAIIANBANK",
  DIGITAL_FEDERAL_CREDIT_UNION: "DIGITALFEDERALCREDITUNION",
  CHARLES_SCHWAB_BANK: "CHARLESSCHWABBANK",
  CHARLESSCHWABBANK: "CHARLESSCHWABBANK",
  CAPITAL_ONE: "CAPITALONE",
  CAPITALONE: "CAPITALONE",
  BRANCH_BANKING_AND_TRUST_COMPANY: "BRANCHBANKING",
  BAXTER_CREDIT_UNION: "BAXTERCREDITUNION",
  BAXTERCREDITUNION: "BAXTERCREDITUNION",
  AMERICANEXPRESS: "AMERICANEXPRESSBANK ",
  AMERICAN_EXPRESS: "AMERICANEXPRESSBANK ",
  APEX: "AMERICANEXPRESSBANK ",
  FRANKLINNATIONALBANK: "FRANKLINNATIONALBANK",
  FRANKLIN_NATIONAL_BANK: "FRANKLINNATIONALBANK",
  MERITRUST_CREDIT_UNION: "MERITRUSTCREDITUNION",
  RBS_CITIZENS_NATIONAL: "RBSCITIZENSNATIONAL",
  RBS_CITIZENS: "RBSCITIZENSNATIONAL",
  NAVY: "NAVYFEDERALCREDITUNION",
  NAVYFEDERALCREDITUNION: "NAVYFEDERALCREDITUNION",
  NAVY_FEDERAL_CREDIT_UNION: "NAVYFEDERALCREDITUNION",
  WESTERN_FEDERAL_CREDIT_UNION: "WESTERNFEDERALCREDITUNION",
  WACHOVIABANK: "WACHOVIABANK",
  WACHOVIA_BANK: "WACHOVIABANK",
  THEBANCORPBANK: "THEBANCORPBANK",
  THE_BANCORP_BANK: "THEBANCORPBANK",
  SUTTONBANK: "SUTTONBANK",
  SUTTON_BANK: "SUTTONBANK",
  SUNTRUST_BK_CENTRAL_FL: "SUNTRUSTBKCENTRAL",
  SUNTRUST_BK_CENTRAL: "SUNTRUSTBKCENTRAL",
  SPOKANETEACHERSCREDITUNIONL: "SPOKANETEACHERSCREDITUNION",
  SPOKANETEACHERSCREDITUNION: "SPOKANETEACHERSCREDITUNION",
  SPOKANE_TEACHERS_CREDIT_UNION: "SPOKANETEACHERSCREDITUNION",
};

// Image URL Map
const bank_img_url = {
  AFEDERALCREDITUNION:
    "https://res.cloudinary.com/dwgkoados/image/upload/v1745333939/A_Federal_Credit_Union_ve77hp.png",
  BANK_OF_AMERICA:
    "https://res.cloudinary.com/dwgkoados/image/upload/v1745333938/bank_of_america_j5kxku.png",
  JPMORGANBANK:
    "https://res.cloudinary.com/dwgkoados/image/upload/v1745333937/chase_a1ykzb.png",
  WELLSFARGO:
    "https://res.cloudinary.com/dh2dakoqb/image/upload/v1745336525/WELLS_FARGO_BANK_d7dhdc.png",
  PNC: "https://res.cloudinary.com/dh2dakoqb/image/upload/v1745336518/PNC_BANK__NA_tqm5x7.png",
  CENTRAL_NATIONAL_BANK:
    "https://res.cloudinary.com/dwgkoados/image/upload/v1745333939/central_national_bank_grevnk.png",
  CITI: "https://res.cloudinary.com/dwgkoados/image/upload/v1745333938/citi-logo_uqbrl2.png",
  SUNTRUST:
    "https://res.cloudinary.com/dh2dakoqb/image/upload/v1745336519/SunTrust_Banks_oqf4yo.png",
  ROGUEFEDERALCREDITUNION:
    "https://res.cloudinary.com/dh2dakoqb/image/upload/v1745336518/ROGUE_FEDERAL_CREDIT_UNION_e6nlqx.png",
  NAVYFEDERALCREDITUNION:
    "https://res.cloudinary.com/dh2dakoqb/image/upload/v1745336517/NAVY_FEDERAL_CREDIT_UNION_d1vcdi.png",
  TDBANK:
    "https://res.cloudinary.com/dh2dakoqb/image/upload/v1745336522/TD_BANK_NA_izewkm.png",
  USAAFEDERALBANK:
    "https://res.cloudinary.com/dh2dakoqb/image/upload/v1745336524/USAA_FEDERAL_SAVINGS_BANK_la7y2r.png",
  SCHWAB:
    "https://res.cloudinary.com/dwgkoados/image/upload/v1745333938/charles_sfokif.png",
  DELTA:
    "https://res.cloudinary.com/dwgkoados/image/upload/v1745333939/delta-company_rwzhoh.png",
  ALLIANTCREDITUNION:
    "https://res.cloudinary.com/dwgkoados/image/upload/v1745333939/alliant_logo_ibeb0g.png",
  PATELCOCREDITUNION:
    "https://res.cloudinary.com/dh2dakoqb/image/upload/v1745336517/PATELCO_CREDIT_UNION_qcdh8n.png",
  MIDDLESEXFEDFA:
    "https://res.cloudinary.com/dh2dakoqb/image/upload/v1745336517/MIDDLESEX_bycfqa.png",
  DISCOVERBANK:
    "https://res.cloudinary.com/dwgkoados/image/upload/v1745333938/Discover_Global_Network_Logo_t0iuka.png",
  KEYBANKNATIONAL:
    "https://res.cloudinary.com/dwgkoados/image/upload/v1745333937/key_bank_xqvmbt.png",
  FIFTHTHIRDBANK:
    "https://res.cloudinary.com/dwgkoados/image/upload/v1745333937/fifth_thrid_mhtc3g.png",
  REGIONSBANK:
    "https://res.cloudinary.com/dh2dakoqb/image/upload/v1745336517/REGIONS_BANK_ybyrg0.png",
  SCHOOLSFIRSTFEDERALCREDITUNION:
    "https://res.cloudinary.com/dh2dakoqb/image/upload/v1745336518/SCHOOLSFIRST_FEDERAL_CREDIT_UNION_vfxktw.png",
  SOVEREIGNBANK:
    "https://res.cloudinary.com/dh2dakoqb/image/upload/v1745336518/SOVEREIGN_BANK_map4vw.png",
  STBANK:
    "https://res.cloudinary.com/dh2dakoqb/image/upload/v1745336518/S_T_BANK_pkyiug.png",
  SUNCOAST:
    "https://res.cloudinary.com/dh2dakoqb/image/upload/v1745336518/SUNCOAST_SCHOOLS_FCU_rhi8j4.png",
  BCU: "https://res.cloudinary.com/dwgkoados/image/upload/v1745333937/bcu_fjhnw7.png",
  LIBERTYBANK:
    "https://res.cloudinary.com/dwgkoados/image/upload/v1745334196/Liberty_Bank_Logo_bscwjq.png",
  TXDOW:
    "https://res.cloudinary.com/dh2dakoqb/image/upload/v1745336523/TX_DOW_EMPLY_CREDIT_a6b6fn.png",
  TINKERFEDERALCREDITUNION:
    "https://res.cloudinary.com/dh2dakoqb/image/upload/v1745336522/TINKER_FEDERAL_CREDIT_UNION_jvqhv2.png",
  TRUWESTCREDITUNION:
    "https://res.cloudinary.com/dh2dakoqb/image/upload/v1745336522/TRUWEST_CREDIT_UNION_qjrrh6.png",
  HUDSON_VALLEY_FCU:
    "https://res.cloudinary.com/dwgkoados/image/upload/v1745333936/hvcu_aqjbch.png",
  WESTERNFEDERALCREDITUNION:
    "https://res.cloudinary.com/dh2dakoqb/image/upload/v1745336525/WACHOVIA_BANK_eu5ib3.png",
  WACHOVIABANK:
    "https://res.cloudinary.com/dh2dakoqb/image/upload/v1745336525/WACHOVIA_BANK_N_nm66yy.png",
  MTBANK:
    "https://res.cloudinary.com/dh2dakoqb/image/upload/v1745336517/mnt_hb1yd3.png",
  LAKEMICHIGANCREDITUNION:
    "https://res.cloudinary.com/dwgkoados/image/upload/v1745334196/Lake_Michigan_rbqw0m.png",
  HUDSON_VALLEY:
    "https://res.cloudinary.com/dwgkoados/image/upload/v1745333936/hvcu_aqjbch.png",
  FIRSTHAWAIIANBANK:
    "https://res.cloudinary.com/dwgkoados/image/upload/v1745333937/hawien_lh74bx.png",
  DIGITALFEDERALCREDITUNION:
    "https://res.cloudinary.com/dwgkoados/image/upload/v1745333938/dcu_uprsyw.png",
  CHARLESSCHWABBANK:
    "https://res.cloudinary.com/dwgkoados/image/upload/v1745333938/charles_sfokif.png",
  CAPITALONE:
    "https://res.cloudinary.com/dwgkoados/image/upload/v1745333939/Capital_One.wine_ndxvwv.png",
  BRANCHBANKING:
    "https://res.cloudinary.com/dwgkoados/image/upload/v1745333937/bbnt_xv1ns5.png",
  BAXTERCREDITUNION:
    "https://res.cloudinary.com/dwgkoados/image/upload/v1745333937/bcu_fjhnw7.png",
  AMERICANEXPRESSBANK:
    "https://res.cloudinary.com/dwgkoados/image/upload/v1745333938/american_express_ukqtcf.png",
  FRANKLINNATIONALBANK:
    "https://res.cloudinary.com/dwgkoados/image/upload/v1745333937/franklin_bank_rptdi5.png",
  MERITRUSTCREDITUNION:
    "https://res.cloudinary.com/dh2dakoqb/image/upload/v1745336517/MERITRUST_CREDIT_UNION_ciabzl.png",
  RBSCITIZENSNATIONAL:
    "https://res.cloudinary.com/dh2dakoqb/image/upload/v1745336517/RBS-Citizens-removebg-preview_enxs2h.png",
  THEBANCORPBANK:
    "https://res.cloudinary.com/dh2dakoqb/image/upload/v1745336522/THE_BANCORP_BANK_ghbrdp.png",
  SUTTONBANK:
    "https://res.cloudinary.com/dh2dakoqb/image/upload/v1745336522/SUTTON_BANK_wmhecs.png",
  SUNTRUSTBKCENTRAL:
    "https://res.cloudinary.com/dh2dakoqb/image/upload/v1745336519/SunTrust_Banks_oqf4yo.png",
  SPOKANETEACHERSCREDITUNION:
    "https://res.cloudinary.com/dh2dakoqb/image/upload/v1745336518/Spokane_eem5he.png",
};

// Normalization Logic
function generateBankKey(name) {
  let normalized = name
    ?.toUpperCase()
    ?.replace(/[^A-Z0-9\s]/g, "") // Remove special characters
    ?.replace(
      /\b(ASSOCIATION|NA|N A|F C U|FCU|SAVINGS|TRUST|COMPANY|NORTHWEST|NW|CU|CHASE|OHIO|FSB|IDAHO|FL|NEVADA|MINNESOTA|SOUTH DAKOTA)\b/g,
      ""
    ) // Remove common junk words
    ?.replace(/\s+/g, "") // Remove all spaces
    ?.trim();

  return aliasOverrides[normalized] || normalized;
}

// URL Fetcher
export function getBankImageURL(bankName) {
  // console.log("Bank Name:", bankName); // Debugging line
  const key = generateBankKey(bankName);
  const imageURL = bank_img_url[key];

  // console.log("Generated Key:", key); // Debugging line
  // console.log("Image URL:", imageURL); // Debugging line

  return imageURL || null;
}

// Your original bank list
// const unique_names = [
//   "A+ FEDERAL CREDIT UNION",
//   "ALLIANT CREDIT UNION",
//   "AMERICAN EXPRESS BANK FSB",
//   "BANK OF AMERICA N.A.",
//   "BANK OF AMERICA NW N.A.- IDAHO",
//   "BANK OF AMERICA, N.A.",
//   "BAXTER CREDIT UNION",
//   "BRANCH BANKING & TRUST COMPANY",
//   "CAPITAL ONE, N.A.",
//   "CENTRAL NATIONAL BANK & TRUST",
//   "CHARLES SCHWAB BANK",
//   "CITIBANK NA",
//   "DELTA COMMUNITY CU",
//   "DIGITAL FEDERAL CREDIT UNION",
//   "DISCOVER BANK",
//   "FIFTH THIRD BANK",
//   "FIRST HAWAIIAN BANK",
//   "FRANKLIN NATIONAL BANK",
//   "HUDSON VALLEY F.C.U.",
//   "J.P. MORGAN CHASE BANK, N.A.",
//   "JPMORGAN CHASE",
//   "JPMORGAN CHASE BANK, NA",
//   "KEY BANK NATIONAL ASSOCIATION",
//   "LAKE MICHIGAN CREDIT UNION",
//   "LIBERTY BANK",
//   "M & T BANK",
//   "MERITRUST CREDIT UNION",
//   "MIDDLESEX FED. SAVINGS, F.A.",
//   "NAVY FEDERAL CREDIT UNION",
//   "PATELCO CREDIT UNION",
//   "PNC BANK, NA",
//   "PNC BANK, OHIO",
//   "REGIONS BANK",
//   "RBS CITIZENS, NATIONAL ASSOCIATION",
//   "ROGUE FEDERAL CREDIT UNION",
//   "S & T BANK",
//   "SCHOOLSFIRST FEDERAL CREDIT UNION",
//   "SOVEREIGN BANK",
//   "SPOKANE TEACHERS CREDIT UNION",
//   "SUNCOAST SCHOOLS FCU",
//   "SUNTRUST BK CENTRAL FL",
//   "SUTTON BANK",
//   "TD BANK, NA",
//   "THE BANCORP BANK",
//   "TINKER FEDERAL CREDIT UNION",
//   "TRUWEST CREDIT UNION",
//   "TX DOW EMPLY CREDIT",
//   "USAA FEDERAL SAVINGS BANK",
//   "WACHOVIA BANK  N.A.",
//   "WELLS FARGO BANK",
//   "WELLS FARGO BANK ,N.A.",
//   "WELLS FARGO BANK NA",
//   "WELLS FARGO BANK NA (NEVADA)",
//   "WELLS FARGO BANK NA  (MINNESOTA)",
//   "WELLS FARGO BANK NA (SOUTH DAKOTA)",
//   "WESTERN FEDERAL CREDIT UNION",
// ];

// unique_names.forEach((name) => {
//   console.log(
//     `${name} -> ${generateBankKey(name)} -> ${getBankImageURL(name)}`
//   );
// });
